import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardTitle, Button } from 'reactstrap';
import { CSVLink } from 'react-csv';
import moment from 'moment';

import IntlMessages from '../../../../../../helpers/IntlMessages';
import ReactTable from 'react-table';
import DataTablePagination from '../../../../../../components/DatatablePagination';

const Region = ({ labels, data, fromDate, toDate, isVoice = false }) => {
  const [csvData, setCSVData] = useState([]);
  useEffect(() => {
    var tablePrint = [
      {
        r1: '',
        r2: 'Website Visit by Region',
        r3: '',
        r4: '',
      },
      {},
      {
        r1: 'Start Date :' + fromDate,
        r2: '',
        r3: 'End Date :' + toDate,
        r4: '',
      },
      {},
      {
        r1: 'Region',
        r2: 'Web Visitors',
        r3: 'Avatar Clicks',
        r4: 'Conversations',
      },
    ];
    if (data.length > 0) {
      data.map((elem) => {
        tablePrint.push({
          r1: elem.region,
          r2: elem.visitors,
          r3: elem.botClicks,
          r4: elem.conversations,
        });
      });
    }
    setCSVData(tablePrint);
  }, [data]);
  return (
    <Card>
      <div style={{ padding: '15px' }}>
        <div className="float-left float-none-xs">
          <div className="d-inline-block">
            <h5 className="d-inline">
              {isVoice ? (
                'Calls By Region'
              ) : (
                // <IntlMessages id="dashboards.visit-country" />
                <span>Website Visit by Region</span>
              )}
            </h5>
            <span className="text-muted text-small d-block">
              <IntlMessages id="dashboards.visit-traffic" />
            </span>
          </div>
        </div>
        <div className="float-right">
          <CSVLink
            data={csvData}
            headers={[
              { key: 'r1', label: '' },
              { key: 'r2', label: '' },
              { key: 'r3', label: '' },
              { key: 'r4', label: '' },
            ]}
            filename="website-visit-by-region.csv"
          >
            <Button color="primary" outline size="xs">
              <IntlMessages id='dashboards.download' />
            </Button>
          </CSVLink>
        </div>
      </div>
      <CardBody>
        <ReactTable
          data={data}
          columns={labels}
          defaultPageSize={5}
          filterable={false}
          showPageJump={true}
          PaginationComponent={DataTablePagination}
          showPageSizeOptions={true}
          defaultSorted={[
            {
              id: 'conversations',
              desc: true,
            },
          ]}
        />
      </CardBody>
    </Card>
  );
};

export default Region;
